import { createReducer, on, ReducerTypes } from '@ngrx/store';
import { produce } from 'immer';
import { Client } from 'src/app/models/create-order';
import {
  setSessionDebtsId,
  setSessionCheckoutCardRecurrence,
  setSessionCheckoutCredit,
  setSessionCheckoutDebit,
  setSessionCheckoutHasRecurrence,
  setSessionClient,
  setSessionClientAddress,
  setSessionIsPaying,
  setSessionDocumentClient,
} from './session.actions';
import { sessionIntialState, SessionState } from './session.types';

const RecurrenceReducers: ReducerTypes<
  SessionState,
  [typeof setSessionCheckoutHasRecurrence | typeof setSessionCheckoutCardRecurrence]
>[] = [
  on(setSessionCheckoutHasRecurrence, (state, { actived }) =>
    produce(state, (draft) => {
      draft.checkout.recurrence.isActivedByCheckout = actived;
    })
  ),
  on(setSessionCheckoutCardRecurrence, (state, { brand, lastFourDigits }) =>
    produce(state, (draft) => {
      draft.checkout.recurrence.card = { brand, lastFourDigits };
    })
  ),
];

const FormPaymentReducers: ReducerTypes<
  SessionState,
  [typeof setSessionCheckoutCredit | typeof setSessionCheckoutDebit | typeof setSessionIsPaying]
>[] = [
  on(setSessionCheckoutCredit, (state, { credit }) =>
    produce(state, (draft) => {
      draft.checkout.credit = { ...credit };
    })
  ),

  on(setSessionCheckoutDebit, (state, { debit }) =>
    produce(state, (draft) => {
      draft.checkout.debit = { ...debit };
    })
  ),

  on(setSessionIsPaying, (state, { isPaying }) =>
    produce(state, (draft) => {
      draft.checkout.isPaying = isPaying;
    })
  ),
];

const ClientReducers: ReducerTypes<
  SessionState,
  [
    | typeof setSessionClient
    | typeof setSessionDebtsId
    | typeof setSessionClientAddress
    | typeof setSessionDocumentClient,
  ]
>[] = [
  on(setSessionClient, (state, { client }) =>
    produce(state, (draft) => {
      const clients: Client = { ...client };
      if (!clients.address) clients.address = draft.client.address;
      draft.client = client;
    })
  ),

  on(setSessionClientAddress, (state, { address }) =>
    produce(state, (draft) => {
      draft.client = { ...draft.client, address: address };
    })
  ),

  on(setSessionDocumentClient, (state, { client }) =>
    produce(state, (draft) => {
      draft.client = { ...draft.client, ni: client.ni, address: draft.client.address };
    })
  ),

  on(setSessionDebtsId, (state, { debtsIds }) =>
    produce(state, (draft) => {
      draft.debtsIds = debtsIds;
    })
  ),
];

export const sessionReducer = createReducer<SessionState>(
  sessionIntialState,
  ...FormPaymentReducers,
  ...RecurrenceReducers,
  ...ClientReducers
);
